import { useState } from 'react';
import getFastDrugSearch, {
  GetFastDrugSearhRequest,
  GetFastDrugSearhResponse
} from '../requests/getFastDrugSearch';
import { APIError, APIHookResponse } from '../types';

interface GetDrugListByNameHookResponse extends APIHookResponse {
  getDrugListByName: (
    requestObj: GetFastDrugSearhRequest,
    fastVariant?: boolean
  ) => Promise<GetFastDrugSearhResponse>;
}

const useGetDrugListByName = (): GetDrugListByNameHookResponse => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<APIError>(null);

  const getDrugListByName = async (
    requestObj: GetFastDrugSearhRequest
  ): Promise<GetFastDrugSearhResponse> => {
    setIsLoading(true);
    try {
      const response = await getFastDrugSearch(requestObj);
      return response;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    getDrugListByName,
    isLoading,
    error
  };
};

export default useGetDrugListByName;
